import  { UserModel } from "store/types/models";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  user:{} as UserModel,
  userPhone:"",
  isAuthenticated:false,
  token : "",
};

export const userSlice = createSlice({
  name: "UserSlice",
  initialState: initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = {...state.user, ...action.payload}
    },

    setAuthentication: (state) => {
      state.isAuthenticated = true
    },

    setUserPhone: (state, action) => {
      state.userPhone = action.payload 
    },

    setToken: (state, action:PayloadAction<string>) => {
      state.token = action.payload 
    },

    clearUserPhone: (state) => {
      state.userPhone = "" 
    },

    updateProfileImage: (state, action) => {
      state.user = {...state.user, image_url:action.payload}
    },

    logoutUser: (state) => {
      state.user = {} as UserModel
      state.isAuthenticated = false
    },

  },
});

export const { setUser, setUserPhone, clearUserPhone, setToken,setAuthentication,updateProfileImage, logoutUser } =
  userSlice.actions;

export default userSlice.reducer;